/** @format */

import "../polyfill";
import $ from "jquery";
import "jquery-validation";

import { requestLoginCode } from "../requests/post";
import { WebLoginVerifyComponent } from "../account/components/WebLoginVerifyComponent";
import { DI } from "../DI";
import { OAuthVerifyComponent } from "../account/components/OAuthVerifyComponent";
import { BaseVerifyIdentityComponent } from "../account/components/BaseVerifyIdentityComponent";

let form = $("[data-login-form]");
let explainer = $("[data-login-explainer]");
let verify = $("[data-login-code]");
let pageTitle = $("[data-login-title]");
let verifyComponent: BaseVerifyIdentityComponent;

function validate() {
    (form as any).validate({
        onKeyup: true,
        rules: {
            email: {
                required: true,
                email: true,
            },
        },
    } as any);
}

function setupListeners() {
    form.on("submit", (event: JQuery.TriggeredEvent) => {
        event.preventDefault();
        login();
    });

    $("[data-submit]").on("click", () => {
        login();
    });
}

function _show_error(message: string) {
    form.hide();
    explainer.html(message);
}

async function login() {
    if (!(form as any).valid()) {
        return;
    }

    let email = $("input[name=email]").val() as string;
    let submitButton = $("[data-submit]");
    let originalButtonText = submitButton.html();

    // Show loader
    submitButton.html("<div class='loader'></div>");
    submitButton.prop("disabled", true);

    try {
        await requestLoginCode(email);
        form.hide();
        verify.show();

        const verifyElement = verify.find(
            `[${WebLoginVerifyComponent.selector}],[${OAuthVerifyComponent.selector}]`
        );
        verifyComponent = DI.getComponentInstanceByElement(
            verifyElement
        ) as BaseVerifyIdentityComponent;
        if (verifyComponent) {
            verifyComponent.initializeWithEmail(email);
        }

        pageTitle.text(window.gettext("Check your email"));
    } catch (error) {
        // Restore button on error
        submitButton.html(originalButtonText);
        submitButton.prop("disabled", false);

        if (error.name === "NotOkResponseError") {
            // Check if we have a custom error message from the server
            if (error.body && error.body.error) {
                _show_error(window.gettext(error.body.error));
            } else {
                _show_error(
                    window.gettext(
                        `Whoops, something went wrong. Please try again later.`
                    )
                );
            }
        } else {
            _show_error(
                window.gettext(
                    `Whoops, something went wrong. Please try again later.`
                )
            );
        }
    }
}

export function setup() {
    validate();
    setupListeners();
}
